import type { BaseSyntheticEvent } from 'react';
import { IoMdArrowForward, IoMdAttach } from 'react-icons/io';
import { IconButton } from '@ds';

export const AttachmentSelectorInitiationButtonContents = () => <IoMdAttach size={20} />;

type SendButtonProps = {
  sendMessage: (event: BaseSyntheticEvent) => void;
  disabled?: boolean;
};

export const SendButton = ({ sendMessage, disabled }: SendButtonProps) => (
  <IconButton
    variant="solid"
    size="xs"
    onClick={(e) => sendMessage(e)}
    startContent={<IoMdArrowForward size={16} />}
    isDisabled={disabled}
  />
);
